<template>
  <v-list nav dense>
    <template v-for="(item, key) in items">
      <v-list-group
        active-class="white--text"
        v-if="item.subRoutes != null"
        :key="key"
      >
        <template v-slot:activator>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </template>
        <template v-for="(itemSub, subKey) in item.subRoutes">
          <v-list-item
            :key="subKey"
            link
            :to="itemSub.path"
            active-class="white--text"
            v-if="itemSub.isAuthorized"
          >
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-list-item-content class="pl-4" v-on="on">
                  <v-list-item-title v-text="itemSub.title"></v-list-item-title>
                </v-list-item-content>
              </template>
              <span>{{ itemSub.title }}</span>
            </v-tooltip>
          </v-list-item>
        </template>
      </v-list-group>
      <template v-else>
        <template v-if="item.isAuthorized">
          <v-list-item :to="item.path" active-class="white--text" :key="key">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-list-item-content v-on="on">
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </v-list-item>
        </template>
      </template>
    </template>
  </v-list>
</template>
<script>
const API_ENDPOINT = "/api/routing";
export default {
  data: () => ({
    items: []
  }),
  methods: {
    getMenu() {
      this.$axios
        .get(`${API_ENDPOINT}/personnel-movement`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    }
  },
  mounted() {
    this.getMenu();
  }
};
</script>